/**
 * The line that keeps a functional parody from reading as the real thing.
 *
 * In the show these portals are set dressing, and context does the work. On the
 * open web a working crowdfunding site called Blickstarter has no such context,
 * so it says what it is. This is the single most load-bearing component here:
 * the satire is fine, being MISTAKEN for the original is not.
 *
 * Every portal renders this. It is not optional and it is not a footer easter
 * egg — put it where a visitor will actually see it.
 */

export const DISCLOSURE_TEXT =
  'A fictional service from a television show. It is a parody, it is not affiliated with any real platform, and any resemblance is the joke.'

export interface PortalDisclosureProps {
  /** The in-world brand, e.g. "Regretsit". */
  portal: string
  /** Optional extra clause — e.g. what this particular portal really does. */
  detail?: string
  className?: string
}

export function PortalDisclosure({ portal, detail, className }: PortalDisclosureProps) {
  return (
    <aside className={className} data-portal-disclosure={portal}>
      <p>
        <strong>{portal}</strong> — {DISCLOSURE_TEXT}
        {detail ? ` ${detail}` : ''}
      </p>
    </aside>
  )
}

export default PortalDisclosure
